var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../service/api.service';
import { ContentBaseService } from '../base/contentbase.service';
import { ColumnService } from '../../items/columns/column/column.service';
var AddRowService = /** @class */ (function (_super) {
    __extends(AddRowService, _super);
    function AddRowService(logger, api, colService) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        _this.colService = colService;
        _this._subject = new Subject();
        _this.uniqueKeys = {};
        return _this;
    }
    Object.defineProperty(AddRowService.prototype, "observable", {
        get: function () {
            return this._subject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    AddRowService.prototype.next = function (compName, flg, err) {
        if (compName === void 0) { compName = ''; }
        if (flg === void 0) { flg = false; }
        if (err === void 0) { err = []; }
        this._subject.next({ compName: compName, flg: flg, err: err });
    };
    AddRowService.prototype.setUniqueKeys = function (compName, uniqueKeys) {
        this.uniqueKeys[compName] = uniqueKeys;
    };
    AddRowService.prototype.getUniqueKeys = function (compName) {
        return this.uniqueKeys[compName] || [];
    };
    AddRowService.prototype.deleteUniqueKeys = function (compName) {
        delete this.uniqueKeys[compName];
    };
    AddRowService.prototype.checkDuplicate = function (compName, items, msg) {
        var _this = this;
        var errItems = [];
        var uniqueKeys = this.getUniqueKeys(compName);
        var _loop_1 = function (i) {
            var checkItems = items.slice(0, i);
            var errItem = {};
            if (items[i].$type === "delete" /* Delete */) {
                return "continue";
            }
            Object.keys(items[i]).filter(function (key) { return uniqueKeys.indexOf(key) >= 0; }).forEach(function (key) {
                var dup = checkItems.some(function (item) {
                    var v = item[key];
                    if (_this.colService.checkVal(v) && _this.colService.checkVal(items[i][key]) && v === items[i][key]) {
                        return true;
                    }
                });
                if (dup) {
                    errItem[key] = [msg['au.COMPONENT.AddRowComponent.error.duplicated']];
                }
            });
            errItems.unshift(errItem);
        };
        for (var i = items.length - 1; i >= 0; i--) {
            _loop_1(i);
        }
        return errItems;
    };
    AddRowService.prototype.refreshCol = function () {
        this.colService.refresh();
    };
    AddRowService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    AddRowService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService },
        { type: ColumnService }
    ]; };
    return AddRowService;
}(ContentBaseService));
export { AddRowService };
var Item = /** @class */ (function () {
    function Item() {
        this.$type = "post" /* Post */;
        this.$editable = true; // 行の編集可否
    }
    return Item;
}());
export { Item };
//# sourceMappingURL=addrow.service.js.map